import React, { Component } from "react";
import { connect } from "react-redux";

import {
  fetchAwardLeaders,
  fetchAvailableAwards
} from "../../redux/actions/leaderboardActions";
import Leaderboard from "../../views/Performance/Leaderboard";

class LearningCenterLeaderboard extends Component {
  componentDidMount() {
    this.props.fetchAwardLeaders();
    this.props.fetchAvailableAwards();
  }

  render() {
    const { user, awardLeadersData, availableAwards } = this.props;
    return (
      !!user &&
      !!availableAwards && (
        <Leaderboard
          user={user}
          awardLeadersData={awardLeadersData}
          availableAwards={availableAwards}
        />
      )
    );
  }
}

const mapStateToProps = state => ({
  awardLeadersData: state.leaderboardState.awardLeadersData,
  availableAwards: state.leaderboardState.availableAwards,
  user: state.leaderboardState.awardLeadersData.userAchievements,
  error: state.leaderboardState.error
});

export default connect(mapStateToProps, {
  fetchAwardLeaders,
  fetchAvailableAwards
})(LearningCenterLeaderboard);
